import { createAction } from 'typesafe-actions';

import { ActionTypes, PageViews } from './auth/constants/auth';
import * as D from './deps';

type LoginFailedParams = string | $TSFixMe;
interface LoginFailedPayload {
  page_view: typeof PageViews.LOGIN_FAILED;
  view_mode: LoginFailedParams;
}

export const loginFailed = createAction(
  ActionTypes.LOGIN_FAILED,
  (viewMode: LoginFailedParams = '') => ({
    page_view: PageViews.LOGIN_FAILED,
    view_mode: viewMode,
  }),
)<LoginFailedPayload>();
export type LoginFailedAction = ReturnType<typeof loginFailed>;

type LoginViewUpdatedParams = string | $TSFixMe;
interface LoginViewUpdatedPayload {
  page_view: typeof PageViews.LOGIN;
  view_mode: LoginViewUpdatedParams;
}

export const loginViewUpdated = createAction(
  ActionTypes.LOGIN_VIEW_UPDATED,
  (viewMode: LoginViewUpdatedParams = '') => ({
    page_view: PageViews.LOGIN,
    view_mode: viewMode,
  }),
)<LoginViewUpdatedPayload>();
export type LoginViewUpdatedAction = ReturnType<typeof loginViewUpdated>;

type RegisterViewUpdatedParams = string | $TSFixMe;
interface RegisterViewUpdatedPayload {
  page_view: typeof PageViews.REGISTRATION;
  view_mode: RegisterViewUpdatedParams;
}

export const registerViewUpdated = createAction(
  ActionTypes.REGISTER_VIEW_UPDATED,
  (viewMode: RegisterViewUpdatedParams = '') => ({
    page_view: PageViews.REGISTRATION,
    view_mode: viewMode,
  }),
)<RegisterViewUpdatedPayload>();
export type RegisterViewUpdatedAction = ReturnType<typeof registerViewUpdated>;

type LogoutParams = $TSFixMe;
interface LogoutPayload {
  username: LogoutParams;
}

export const logout = createAction(ActionTypes.LOGOUT, (username: LogoutParams) => {
  if (!username) {
    throw new Error('logout(): username is required');
  }

  return { username };
})<LogoutPayload>();
export type LogoutAction = ReturnType<typeof logout>;

export const logoutFromCommunity = createAction(ActionTypes.LOGOUT_FROM_COMMUNITY)();
export type LogoutFromCommunityAction = ReturnType<typeof logoutFromCommunity>;

interface RegisterParams {
  birthDay: number | $TSFixMe;
  birthMonth: number | $TSFixMe;
  birthYear: number | $TSFixMe;
  gender: $TSFixMe;
  keepLoggedIn: $TSFixMe;
  password: $TSFixMe;
  username: $TSFixMe;
  zipcode: $TSFixMe;
}
type RegisterPayload = RegisterParams;

export const register = createAction(
  D.Constants.ListenerExternals.Actions.REGISTER,
  ({
    username,
    password,
    birthDay = 1,
    birthMonth = 1,
    birthYear,
    zipcode,
    gender,
    keepLoggedIn,
  }: RegisterParams) => ({
    username,
    password,
    birthDay: D.Utils.NumberUtils.parseNumber(birthDay),
    birthMonth: D.Utils.NumberUtils.parseNumber(birthMonth),
    birthYear: D.Utils.NumberUtils.parseNumber(birthYear),
    zipcode,
    gender,
    keepLoggedIn,
  }),
)<RegisterPayload>();
export type RegisterAction = ReturnType<typeof register>;
